import { useSelector } from 'react-redux';
import { Feature } from '../../../backend_api/models';
import { useCheckHasFeature } from '../../../base/hooks';
import { getFeaturesSelector } from '../../../base/selectors';

export function useHasIndependentProductionUnits(): boolean {
    const features = useSelector(getFeaturesSelector);
    const independentProductionUnitsEnabled = useCheckHasFeature(features, Feature.IndependentProductionUnits);
    return independentProductionUnitsEnabled;
}